<template lang='pug'>
section
  s-page-title(:previous='true' :title='item.name' subtitle='Акции')
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          div(class='mb-3')
            div(class='grey--text') Название
            div(class='subheading') {{ item.name }}
          div(class='mb-3')
            div(class='grey--text') Описание
            div(class='subheading') {{ item.description }}
          div(class='mb-3')
            div(class='grey--text') Скидка
            div(class='subheading') {{ item.discount || 0 }}%
          div(class='mb-3')
            div(class='grey--text') Время начала
            div(class='subheading')
              | {{ item.start_time | date("DD MMM YYYY HH:mm") }}
          div(class='mb-3')
            div(class='grey--text') Время завершения
            div(class='subheading')
              | {{ item.stop_time | date("DD MMM YYYY HH:mm") }}
          div(class='mb-3')
            div(class='grey--text') Статус
            div(
              :class=`{
                'subheading': true,
                'accent--text': item.status === statuses.rejected,
                'primary--text': item.status === statuses.accepted
              }`
            ) {{ item.status_name }}
          div(class='mb-3')
            div(class='grey--text') Комментарий
            div(class='subheading') {{ item.moderation_comment }}
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        v-if='isRejectVisible()'
        :loading='isLoading'
        @click='openRejectDialog'
        color='accent'
        depressed
      )
        v-icon(left) thumb_down_alt
        | Отклонить акцию
      v-btn(
        v-if='isAcceptVisible()'
        :loading='isLoading'
        @click='onAccept'
        color='primary'
        depressed
      )
        v-icon(left) thumb_up_alt
        | Принять акцию
  v-dialog(v-model='dialog' persistent max-width='400px')
    v-card
      v-card-text
        v-container(class='pa-0')
          v-layout(wrap)
            v-flex(xs12)
              v-textarea(
                v-model='comment'
                :error='errors.has("comment")'
                :error-messages='errors.first("comment")'
                label='Укажите причину отказа'
                autofocus
                required
              )
      v-card-actions
        v-spacer
        v-btn(flat @click='dialog = false') Отмена
        v-btn(color='primary' flat @click='onReject') OK
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  data: () => ({
    item: {},
    comment: null,
    dialog: false,
    statuses: {
      accepted: 'accepted',
      rejected: 'rejected',
      moderate: 'moderate'
    }
  }),

  created() {
    this.updateItem()
  },

  methods: {
    async updateItem() {
      if (this.id) {
        try {
          this.item = (await this.fetchSingle({ id: this.id })).data
        } catch (e) {
          this.$showServerErrors(e)
        }
      }
    },

    async onAccept() {
      if (!this.isLoading && (await this.$confirm('Принять акцию?'))) {
        try {
          await this.accept({ id: this.item.id })
          this.updateItem()
        } catch (e) {
          this.$showServerErrors(e)
        }
      }
    },

    async onReject() {
      if (this.isLoading) {
        return
      }

      if (null === this.comment) {
        this.errors.add({
          field: 'comment',
          msg: 'Поле обязательно для заполнения'
        })

        return
      }

      if (!await this.$confirm('Отклонить акцию?')) {
        return
      }

      this.dialog = false

      try {
        await this.reject({
          id: this.item.id,
          comment: this.comment
        })

        this.updateItem()
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    openRejectDialog() {
      this.dialog = true
    },

    isRejectVisible() {
      switch (this.item.status) {
        case this.statuses.moderate:
        case this.statuses.accepted:
          return true
      }

      return false
    },

    isAcceptVisible() {
      switch (this.item.status) {
        case this.statuses.moderate:
        case this.statuses.rejected:
          return true
      }

      return false
    },

    ...mapActions('partners/actions', [
      'fetchSingle',
      'update',
      'accept',
      'reject'
    ])
  },

  computed: {
    ...mapGetters('partners/actions', ['isLoading'])
  },

  watch: {
    dialog() {
      this.errors.remove('comment')
      this.comment = null
    },

    comment() {
      this.errors.remove('comment')
    }
  }
}
</script>
